
<div class="to-dialog-title">
	<div>{{viewItem.name}}</div>
	<button mat-icon-button (mousedown)="cancel()">
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>
</div>

<!--START BODY-->
<div class="to-dialog-content" >

	@if (viewItem.imageURL) {
		<div class="offer-image" [appBgImage]="viewItem.imageURL" [model]="viewItem" [ngStyle]="cardStyle">
			<!--<button class="close-button o-btn _lg _round _shadow _icon brand-primary" type="button" mat-dialog-close cdkFocusInitial>
				<mat-icon class="lg" svgIcon="close"></mat-icon>
			</button>-->
		</div>
	}
	<div >
		@if (viewItem.description || viewItem.offerAttributes || nutritionalData) {
			<div class="offer-description">
				{{ viewItem.description }}

				@if (nutritionalData || viewItem.offerAttributes) {
					<div class="mt-3" style="display: flex; justify-content: space-between">

						@if (viewItem.offerAttributes) {
						<div class="item-attributes-desc">
							@for (att of viewItem.offerAttributes; track att) {
								<div>
									<img [src]="att.icon"/>
									<span>{{ 'name' | objTranslate:att }}</span>
								</div>
							}
						</div>
						}
						<div style="min-width: 10px"></div>
						@if (nutritionalData) {
							<!--<div class="text-accent" style="display: flex; align-items: center; gap:5px; text-decoration: underline" (mousedown)="showItemInfo()">
								<mat-icon svgIcon="clipboard_list"></mat-icon>
								<span>{{ 'nutritional_info' | translate }}</span>
							</div>-->
							<button matButton="outlined" color="accent" (mousedown)="showItemInfo()" class="text-accent" style="font-size: 0.85rem;">
								<mat-icon svgIcon="clipboard_list"></mat-icon>
								<span>{{ 'nutritional_info' | translate }}</span>
							</button>
						}

					</div>
				}





			</div>
		}
		<ng-container *ngIf="!viewItem.isWeight else weightItem">
			@for (step of wizardStepsParsed; track step) {
				<div class="_dialog-content-innerstep">
					@for (group of step.members | filterBy:{'_prepared': true}; track group._id) {
						@if (group.modifierGroup && group._visible !== false) {
							<app-modifier-group [viewItem]="viewItem" [currentItem]="currentItem"
												[workMode]="'offer'" [group]="group"></app-modifier-group>
						} @else if (group.itemGroup) {
							<app-item-group [viewItem]="viewItem" [currentItem]="currentItem" [group]="group"
											[workMode]="step.members.length > 1 ? 'inline' : 'wizard'"
											(onMemberSelect)="onItemGroupSelect()"></app-item-group>
						}
					}
				</div>
			}
		</ng-container>
	</div>
</div>
<!--END BODY-->
<div class="to-dialog-actions">
	<!--<button mat-stroked-button  (mousedown)="cancel()">{{'TD.cancel' | translate}}</button>-->
	<div class="to-dialog-actions-counter">
		<button mat-icon-button color="accent" (mousedown)="setOfferQuantity(-1)">
			<mat-icon [svgIcon]="viewItem.quantity == 1 && isEdit ? 'trash' : 'minus_circle'" ></mat-icon>
		</button>

		<div class="offer-counter-txt">{{viewItem.quantity}}</div>

		<button mat-icon-button  color="accent" (mousedown)="setOfferQuantity(1)">
			<mat-icon svgIcon="plus_circle"></mat-icon>
		</button>
	</div>

	<button mat-flat-button color="accent" (mousedown)="submit()" class="rounded" style="min-width: 160px;">
		<div class="d-flex justify-content-between align-items-center">
			<span>{{(isEdit && !isDuplicate ? 'TD.to-update' : 'TD.to-add') | translate}}</span>
			<span class="ml-3">{{viewItem.quantity * (viewItem.total || 0) | lcurrency}}</span>
		</div>
	</button>
</div>

<ng-template #weightItem>
	<div>
		<div class="p-5 text-center">
			<div class="icrement-box mt-4">
				<button class="brand-accent _start" type="button" (click)="incrementWeight(-1)">
					<mat-icon svgIcon="minus"></mat-icon>
				</button>
				<div class="_info">
					<span>{{viewItem.units}} {{$storage.catalog.weightParams.useTxt}}</span>
				</div>
				<button class="brand-accent _end" type="button" (click)="incrementWeight(1)">
					<mat-icon svgIcon="plus"></mat-icon>
				</button>
			</div>
			<div class=" mt-4 text-xl">
				<div class="increment-box-subtitle">{{viewItem.pricePer}}</div>
			</div>
		</div>
	</div>
</ng-template>
